<template>
<div class="page-effect">
<div class="page-support-message d-flex justify-content-center align-items-center flex-column">
	<h4 class="error-top">We're sorry, but<br>your device isn't supported</h4>
	<img src="../assets/Images/unsupported_resolution.png"/>
	<p>As an attendee your experience is our priority.</p>
	<p>Please join using Chrome or Edge browser from Desktop</p>
	<p class="mb-0">or</p>
	<a href="" class="app-download-btn">Download Mobile App Now </a>
</div>
</div>
</template>
<script>
//import Vue from "vue";
import jQuery from "jquery";
let $ = jQuery;
export default {
mounted() {
$("#topmenu").hide();
$("#leftmenu").hide();
},
};
</script>
<style>
h4.error-top {
    font-size: 18px;
    margin: 0;
    font-weight: 600;
	color: #fff;
	text-align: center;
}
.page-support-message p {
    text-align: center;
    color: #ffffff;
    width: 216px;
    font-size: 14px;
}
a.app-download-btn {
    display: inline-block;
    background: #d2006f;
    color: #ffffff;
    font-size: 14px;
    margin-top: 23px;
    padding: 10px 20px;
    font-weight: 500;
    border-radius: 3px;
    position: relative;
}
</style>